(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merrynest-product-purchase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.mn-buy__thumb');
  if (!button) return;
  const root = button.closest('[data-mn-buy]');
  const image = root.querySelector('.mn-buy__main');
  image.removeAttribute('srcset');
  image.src = button.dataset.src;
  image.alt = button.dataset.alt;
  root.querySelectorAll('.mn-buy__thumb').forEach(function(item) { item.setAttribute('aria-pressed', String(item === button)); });
});

(function () {
  let observer, page = 0, currentItems = [], lastResizePage = -1;
  function showPage(next) {
    const pages = Math.ceil(currentItems.length / 2);
    if (!pages) return;
    page = (next + pages) % pages;
    if (lastResizePage !== page) { lastResizePage = page; requestAnimationFrame(function() { window.dispatchEvent(new Event('resize')); }); }
    currentItems.forEach(function(item, index) { item.hidden = Math.floor(index / 2) !== page; });
    document.querySelectorAll('.mn-review-dot').forEach(function(dot, index) { dot.setAttribute('aria-current', String(index === page)); });
  }
  function setup() {
    const rating = document.querySelector('.mn-buy__rating');
    const reviews = document.getElementById('bk-reviews-section');
    if (!rating || !reviews) return;
    reviews.querySelectorAll('button').forEach(function(button) {
      if (button.textContent.trim() === 'Write a review') button.textContent = 'Bewertung schreiben';
      if (button.textContent.trim() === 'Show more') button.textContent = 'Mehr anzeigen';
    });
    const widget = reviews.closest('.bk-reviews') || reviews;
    const info = document.querySelector('.mn-buy__info');
    if (widget.parentElement !== info) info.querySelector('h1').after(widget);
    const cards = Array.from(reviews.querySelectorAll('.tw-break-inside-avoid'));
    if (!cards.length) return;
    const grid = cards[0].parentElement.parentElement.parentElement;
    const columns = Array.from(grid.children);
    const items = [];
    for (let row = 0; row < Math.max.apply(null, columns.map(function(col) { return col.children.length; })); row++) {
      columns.forEach(function(col) { if (col.children[row]) items.push(col.children[row]); });
    }
    grid.classList.add('mn-review-grid');
    grid.parentElement.classList.add('mn-review-stage');
    const oldDots = reviews.querySelector('.mn-review-dots');
    if (oldDots && oldDots.children.length !== Math.ceil(items.length / 2)) { reviews.querySelector('.mn-review-controls').remove(); oldDots.remove(); }
    items.forEach(function(item, index) { item.classList.add('mn-review-item'); item.style.order = index; });
    currentItems = items;
    if (rating.nextElementSibling !== grid) grid.before(rating);
    if (!reviews.querySelector('.mn-review-controls')) {
      const controls = document.createElement('div'); controls.className = 'mn-review-controls';
      [['‹','Vorherige Bewertungen',-1],['›','Nächste Bewertungen',1]].forEach(function(config) {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'mn-review-arrow'; button.textContent = config[0]; button.setAttribute('aria-label', config[1]); button.addEventListener('click', function() { showPage(page + config[2]); }); controls.append(button);
      });
      grid.after(controls);
      const dots = document.createElement('div'); dots.className = 'mn-review-dots';
      for (let index = 0; index < Math.ceil(items.length / 2); index++) {
        const dot = document.createElement('button'); dot.type = 'button'; dot.className = 'mn-review-dot'; dot.setAttribute('aria-label', 'Bewertungsseite ' + (index + 1)); dot.addEventListener('click', function() { showPage(index); }); dots.append(dot);
      }
      controls.after(dots);
      let touchX = null;
      grid.addEventListener('touchstart', function(event) { touchX = event.changedTouches[0].clientX; }, { passive:true });
      grid.addEventListener('touchend', function(event) { if (touchX === null) return; const delta = event.changedTouches[0].clientX - touchX; if (Math.abs(delta) > 50) showPage(page + (delta < 0 ? 1 : -1)); touchX = null; }, { passive:true });
    }
    showPage(page);
  }
  function refresh() { observer.disconnect(); setup(); observer.observe(document.body, { childList:true, subtree:true }); }
  function start() { if (!document.querySelector('.mn-buy__rating')) return; observer = new MutationObserver(refresh); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
})();

  } catch(e) { console.error(e); }
})();
})();
